module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('setting-title', {
    attrs: {
      "title": "转化目标设置"
    }
  }, [_c('div', {
    attrs: {
      "id": "backToReport"
    }
  }, [_vm._v("完成本页操作后可"), _c('router-link', {
    attrs: {
      "to": "/web/overview"
    }
  }, [_vm._v("查看分析")])], 1)]), _c('div', {
    staticClass: "zone content-part"
  }, [_c('domain-select', {
    attrs: {
      "extra": "为网站$domain设置转化目标"
    },
    on: {
      "change": _vm.onDomainChange
    }
  }, [_c('span', {
    slot: "front"
  }, [_vm._v("(为网站")]), _c('span', {
    slot: "back"
  }, [_vm._v("设置转化目标)")])])], 1), _c('div', {
    staticClass: "zone content-part paddingbt30 iframe-header"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-list",
      "title": "转化目标设置列表"
    },
    slot: "icon"
  }), _c('hr', {
    staticClass: "header-chart-line no-margin"
  }), _c('ul', {
    staticClass: "tab trans-tab"
  }, _vm._l((_vm.tablist), function(item) {
    return _c('li', {
      staticClass: "tab-item"
    }, [_c('div', {
      staticClass: "tab-item-btn",
      class: {
        active: _vm.currentTab == item.id
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changeTabTo(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.title))])])
  })), (_vm.currentTab == 'system') ? _c('div', [_c('table', {
    staticClass: "data-table",
    staticStyle: {
      "table-layout": "fixed",
      "margin-top": "15px"
    }
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.systemList), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.typedetail))]), _c('td', [_vm._v(_vm._s(item.indice))]), _c('td', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.gotoCodePage(item.type)
        }
      }
    }, [_vm._v("获取" + _vm._s(item.typedetail) + "回传代码")])])])
  }))])]) : (_vm.currentTab == 'custom') ? _c('div', [_c('div', {
    staticClass: "toolbar-row"
  }, [_c('v-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedType),
      expression: "selectedType"
    }],
    attrs: {
      "options": _vm.transtypeSelectList
    },
    domProps: {
      "value": (_vm.selectedType)
    },
    on: {
      "input": [function($event) {
        _vm.selectedType = $event
      }, function($event) {
        _vm.changeListPage(1)
      }]
    }
  }), _c('div', {
    staticClass: "btn btn-primary btn-big",
    on: {
      "click": _vm.openAddTransInfo
    }
  }, [_vm._v("添加转化目标")])], 1), _c('table', {
    staticClass: "data-table",
    staticStyle: {
      "table-layout": "fixed"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "35%"
    }
  }, [_vm._v("转化目标名称")]), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("转化类型")]), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("转化类型细分")]), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("创建时间")]), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("操作")])])]), _c('tbody', [(_vm.isLoading) ? _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_c('img', {
    attrs: {
      "src": "//p.ssl.qhimg.com/t010aba4345b02168d6.gif"
    }
  })])]) : (_vm.isListEmpty) ? _c('tr', [_c('td', {
    staticClass: "noresult",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("请先添加转化目标，然后查看转化效果分析")])]) : (!_vm.isListEmpty) ? _vm._l((_vm.list), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.name))]), _c('td', [_vm._v(_vm._s(_vm._f("transTypeFilter")(item.type)))]), _c('td', [_vm._v(_vm._s(_vm._f("transTypeDetailFilter")(item)))]), _c('td', [_vm._v(_vm._s(item.createtime))]), _c('td', [_c('i', {
      staticClass: "fa fa-eye fa-lg",
      style: ({
        marginRight: '8px'
      }),
      attrs: {
        "title": "查看"
      },
      on: {
        "click": function($event) {
          _vm.showDetail(item, index)
        }
      }
    }), _c('i', {
      staticClass: "fa fa-pencil-square-o fa-lg",
      style: ({
        marginRight: '8px'
      }),
      attrs: {
        "title": "修改"
      },
      on: {
        "click": function($event) {
          _vm.editTransInfo(item, index)
        }
      }
    }), _c('i', {
      staticClass: "fa fa-trash-o fa-lg",
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          _vm.deleteListItem(item, index)
        }
      }
    })])])
  }) : _vm._e()], 2)]), _c('v-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total > 20),
      expression: "total > 20"
    }],
    attrs: {
      "total": _vm.total,
      "pn": _vm.pageNum,
      "ps": "20"
    },
    on: {
      "updatepage": _vm.changeListPage
    }
  }), _c('div', {
    staticClass: "note-text"
  }, [_vm._v("（注：设置转化目标前，请确保基础代码已安装并生效）")])], 1) : _vm._e()], 1), _c('v-modal', {
    ref: "formModal",
    attrs: {
      "visible": _vm.transInfoVisible,
      "title": _vm.transInfoTitle
    },
    on: {
      "closemodal": _vm.closeModal
    }
  }, [(_vm.transInfoDel) ? _c('div', {
    staticClass: "modal-bd"
  }, [_c('p', {
    staticClass: "content-part"
  }, [_vm._v("确定删除么")]), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-small",
    on: {
      "click": _vm.delTransInfo
    }
  }, [_vm._v("确定")]), _c('button', {
    staticClass: "btn btn-default btn-small",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("取消")])])]) : (!_vm.transInfoEdit) ? _c('div', {
    staticClass: "modal-bd"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('v-form', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transInfo),
      expression: "transInfo"
    }],
    domProps: {
      "value": (_vm.transInfo)
    },
    on: {
      "input": function($event) {
        _vm.transInfo = $event
      }
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("转化类型：")]), _c('div', {
    staticClass: "control"
  }, [_vm._v(_vm._s(_vm._f("transTypeFilter")(_vm.transInfo.type)))])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("转化类型细分：")]), _c('div', {
    staticClass: "control"
  }, [_vm._v(_vm._s(_vm._f("transTypeDetailFilter")(_vm.transInfo)))])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("转化目标名称：")]), _c('div', {
    staticClass: "control"
  }, [_vm._v(_vm._s(_vm.transInfo.name))])]), (_vm.transtype === '1') ? _c('div', {
    staticClass: "trans-content"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("目标网页URL：")]), _c('div', {
    staticClass: "control"
  }, [_vm._v(_vm._s(_vm.transInfo.url))])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("高级设置： ")]), _c('div', {
    staticClass: "control"
  }, [_c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.transInfo.route && _vm.transInfo.route.length > 0),
      expression: "transInfo.route && transInfo.route.length > 0"
    }],
    staticClass: "data-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("序号")]), _c('th', [_vm._v("URL")])])]), _c('tbody', _vm._l((_vm.transInfo.route), function(trans, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _c('td', {
      attrs: {
        "title": trans.url
      }
    }, [_vm._v(_vm._s(trans.url))])])
  }))])])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("预期收益：")]), _c('div', {
    staticClass: "control"
  }, [_vm._v(_vm._s(_vm.transInfo.income) + " 元")])]), (_vm.transInfo.rtstrict == '1') ? _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }), _c('div', {
    staticClass: "control"
  }, [_vm._v("只有经过路径的目标才记为转化 （访问路径不包括目标网页URL）")])]) : _vm._e()]) : _vm._e(), (_vm.transtype === '2') ? _c('div', {
    staticClass: "trans-content"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("事件ID：")]), _c('div', {
    staticClass: "control"
  }, [_vm._v(_vm._s(_vm.transInfo.eventid))])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("事件页面URL：")]), _c('div', {
    staticClass: "control"
  }, [_vm._v(_vm._s(_vm.transInfo.url))])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("预期收益：")]), _c('div', {
    staticClass: "control"
  }, [_vm._v(_vm._s(_vm.transInfo.income) + " 元")])])]) : _vm._e(), (_vm.transtype === '3') ? _c('div', {
    staticClass: "trans-content"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("页面URL：")]), _c('div', {
    staticClass: "control"
  }, [_vm._v(_vm._s(_vm.transInfo.url))])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("平均访问时长：")]), _c('div', {
    staticClass: "control"
  }, [_vm._v("大于 " + _vm._s(_vm.transInfo.minutes) + " 分 " + _vm._s(_vm.transInfo.seconds) + " 秒")])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("预期收益：")]), _c('div', {
    staticClass: "control"
  }, [_vm._v(_vm._s(_vm.transInfo.income) + " 元")])])]) : _vm._e(), (_vm.transtype === '4') ? _c('div', {
    staticClass: "trans-content"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("平均访问页数：")]), _c('div', {
    staticClass: "control"
  }, [_vm._v("大于 " + _vm._s(_vm.transInfo.accpage) + " 页")])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("预期收益：")]), _c('div', {
    staticClass: "control"
  }, [_vm._v(_vm._s(_vm.transInfo.income) + " 元")])])]) : _vm._e()])], 1)]) : (_vm.transInfoEdit) ? _c('div', {
    staticClass: "modal-bd"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('v-form', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transInfo),
      expression: "transInfo"
    }],
    ref: "transform",
    attrs: {
      "before-submit": _vm.beforeSubmit
    },
    domProps: {
      "value": (_vm.transInfo)
    },
    on: {
      "input": function($event) {
        _vm.transInfo = $event
      }
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("转化类型：")]), _c('div', {
    staticClass: "control"
  }, [_c('v-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transtype),
      expression: "transtype"
    }],
    attrs: {
      "name": "transtype",
      "options": _vm.transtypeList
    },
    domProps: {
      "value": (_vm.transtype)
    },
    on: {
      "input": function($event) {
        _vm.transtype = $event
      }
    },
    nativeOn: {
      "change": function($event) {
        _vm.errmsgShow = false
      }
    }
  })], 1)]), (_vm.transtype == 1 || _vm.transtype == 2) ? _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("转化类型细分：")]), _c('div', {
    staticClass: "control"
  }, [_c('v-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transInfo.type_d),
      expression: "transInfo.type_d"
    }],
    attrs: {
      "name": "transDetail",
      "options": _vm.transDetailList,
      "required": "required"
    },
    domProps: {
      "value": (_vm.transInfo.type_d)
    },
    on: {
      "input": function($event) {
        _vm.transInfo.type_d = $event
      }
    },
    nativeOn: {
      "change": function($event) {
        _vm.errmsgShow = false
      }
    }
  }), _c('v-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transInfo.remark),
      expression: "transInfo.remark"
    }],
    staticClass: "size-small",
    attrs: {
      "name": "remark",
      "placeholder": _vm.otherDetailPlaceholder,
      "rules": _vm.rules.otherDetail,
      "disabled": _vm.transInfo.type_d !== '4'
    },
    domProps: {
      "value": (_vm.transInfo.remark)
    },
    on: {
      "input": function($event) {
        _vm.transInfo.remark = $event
      }
    }
  }), _c('em', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errmsgShow),
      expression: "errmsgShow"
    }],
    staticClass: "error"
  }, [_vm._v("请输入转化细分")])], 1)]) : _vm._e(), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("转化目标名称：")]), _c('div', {
    staticClass: "control"
  }, [_c('v-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transInfo.name),
      expression: "transInfo.name"
    }],
    attrs: {
      "rules": _vm.rules.title,
      "placeholder": "请输入1-10字符名称"
    },
    domProps: {
      "value": (_vm.transInfo.name)
    },
    on: {
      "input": function($event) {
        _vm.transInfo.name = $event
      }
    }
  })], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.transtype === '1'),
      expression: "transtype ==='1'"
    }],
    staticClass: "trans-content"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("目标网页URL：")]), _c('div', {
    staticClass: "control"
  }, [_c('v-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transInfo.url),
      expression: "transInfo.url"
    }],
    attrs: {
      "rules": _vm.rules.url,
      "placeholder": "请输入URL如：http://aaa.com，可通配"
    },
    domProps: {
      "value": (_vm.transInfo.url)
    },
    on: {
      "input": function($event) {
        _vm.transInfo.url = $event
      }
    }
  }), _c('v-tooltip', {
    attrs: {
      "tip": "若您想监测某注册完成页http://www.aaa.com/sign_up/id=xxx，不同访客有不同id，则目标页面可设置为http://www.aaa.com/sign_up/id=*；若您想监测某页面不同渠道的流量来源数据，可将该目标页面设置为http://www.aaa.com/*",
      "pos": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])], 1)]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("预期收益：")]), _c('div', {
    staticClass: "control"
  }, [_c('v-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transInfo.income),
      expression: "transInfo.income"
    }],
    attrs: {
      "rules": _vm.rules.income,
      "placeholder": "请输入数字"
    },
    domProps: {
      "value": (_vm.transInfo.income)
    },
    on: {
      "input": function($event) {
        _vm.transInfo.income = $event
      }
    }
  }), _vm._v("元")], 1)]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("高级设置：")]), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.transUrlList.length < 5),
      expression: "transUrlList.length < 5"
    }],
    staticClass: "btn",
    class: _vm.addTransUrlClass,
    on: {
      "click": _vm.addTransUrl
    }
  }, [_vm._v("添加经过URL")]), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.transUrlList.length > 0),
      expression: "transUrlList.length > 0"
    }],
    staticClass: "data-table convert-path"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("序号")]), _c('th', [_vm._v("URL")]), _c('th', [_vm._v("操作")])])]), _c('tbody', _vm._l((_vm.transUrlList), function(trans, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), (trans.url != '') ? _c('td', {
      attrs: {
        "title": trans.url
      }
    }, [_vm._v(_vm._s(trans.url))]) : _vm._e(), (trans.url == '') ? _c('td', [_c('v-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.transInfoURL),
        expression: "transInfoURL"
      }],
      ref: "processurl",
      refInFor: true,
      attrs: {
        "rules": _vm.rules.url,
        "placeholder": "请输入URL如：http://aaa.com，可通配"
      },
      domProps: {
        "value": (_vm.transInfoURL)
      },
      on: {
        "input": function($event) {
          _vm.transInfoURL = $event
        }
      }
    })], 1) : _vm._e(), (trans.url == '') ? _c('td', [_c('button', {
      staticClass: "btn btn-primary btn-small",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.saveTransUrl($event)
        }
      }
    }, [_vm._v("保存")]), _c('button', {
      staticClass: "btn btn-default btn-small",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.delcurrentTransUrl(index)
        }
      }
    }, [_vm._v("删除")])]) : _vm._e(), (trans.url != '') ? _c('td', [_c('button', {
      staticClass: "btn btn-default btn-small",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.delTransUrl(index)
        }
      }
    }, [_vm._v("删除")])]) : _vm._e()])
  }))])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.transUrlList.length > 0),
      expression: "transUrlList.length > 0"
    }],
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }), _c('div', {
    staticClass: "control"
  }, [_c('v-checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transInfo.rtstrict),
      expression: "transInfo.rtstrict"
    }],
    domProps: {
      "value": (_vm.transInfo.rtstrict)
    },
    on: {
      "input": function($event) {
        _vm.transInfo.rtstrict = $event
      }
    }
  }), _vm._v("只有按顺序经过以上URL目标才算转化（该URL不可与目标网页URL相同）")], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.transUrlList.length > 0),
      expression: "transUrlList.length > 0"
    }],
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }), _c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v(" 说明：URL设置中均可使用通配符*通配 "), _c('v-tooltip', {
    attrs: {
      "tip": "若您想监测某注册完成页http://www.aaa.com/sign_up/id=xxx，不同访客有不同id，则目标页面可设置为http://www.aaa.com/sign_up/id=*；若您想监测某页面不同渠道的流量来源数据，可将该目标页面设置为http://www.aaa.com/*",
      "pos": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])], 1)])])]), (_vm.transtype === '2') ? _c('div', {
    staticClass: "trans-content"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("事件ID：")]), _c('div', {
    staticClass: "control"
  }, [_c('v-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transInfo.eventid),
      expression: "transInfo.eventid"
    }],
    attrs: {
      "placeholder": "请直接输入ID内容",
      "rules": _vm.rules.eventid
    },
    domProps: {
      "value": (_vm.transInfo.eventid)
    },
    on: {
      "input": function($event) {
        _vm.transInfo.eventid = $event
      }
    }
  }), _c('a', {
    staticClass: "btn btn-icon btn-primary",
    attrs: {
      "target": "_blank",
      "href": "https://fenxi.360.cn/help/manual?target=conversion"
    }
  }, [_vm._v("如何获取？")])], 1)]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("事件页面URL：")]), _c('div', {
    staticClass: "control"
  }, [_c('v-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transInfo.url),
      expression: "transInfo.url"
    }],
    attrs: {
      "rules": _vm.rules.url,
      "placeholder": "请输入URL如：http://aaa.com，可通配"
    },
    domProps: {
      "value": (_vm.transInfo.url)
    },
    on: {
      "input": function($event) {
        _vm.transInfo.url = $event
      }
    }
  }), _c('v-tooltip', {
    attrs: {
      "tip": "若您想监测某注册完成页http://www.aaa.com/sign_up/id=xxx，不同访客有不同id，则目标页面可设置为http://www.aaa.com/sign_up/id=*；若您想监测某页面不同渠道的流量来源数据，可将该目标页面设置为http://www.aaa.com/*",
      "pos": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])], 1)]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("预期收益：")]), _c('div', {
    staticClass: "control"
  }, [_c('v-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transInfo.income),
      expression: "transInfo.income"
    }],
    attrs: {
      "rules": _vm.rules.income,
      "placeholder": "请输入数字"
    },
    domProps: {
      "value": (_vm.transInfo.income)
    },
    on: {
      "input": function($event) {
        _vm.transInfo.income = $event
      }
    }
  }), _vm._v("元")], 1)])]) : _vm._e(), (_vm.transtype === '3') ? _c('div', {
    staticClass: "trans-content"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("页面URL：")]), _c('div', {
    staticClass: "control"
  }, [_c('v-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transInfo.url),
      expression: "transInfo.url"
    }],
    attrs: {
      "rules": _vm.rules.url,
      "placeholder": "请输入URL如：http://aaa.com，可通配"
    },
    domProps: {
      "value": (_vm.transInfo.url)
    },
    on: {
      "input": function($event) {
        _vm.transInfo.url = $event
      }
    }
  }), _c('v-tooltip', {
    attrs: {
      "tip": "添加页面URL则统计访客在该页面访问时长，不添加则统计访客每次访问的平均时长",
      "pos": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])], 1)]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("平均访问时长：")]), _c('div', {
    staticClass: "control ml5"
  }, [_vm._v("大于"), _c('v-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transInfo.minutes),
      expression: "transInfo.minutes"
    }],
    staticClass: "size-small",
    domProps: {
      "value": (_vm.transInfo.minutes)
    },
    on: {
      "input": function($event) {
        _vm.transInfo.minutes = $event
      }
    },
    nativeOn: {
      "input": function($event) {
        _vm.hideErrmsg($event)
      }
    }
  }), _vm._v("分"), _c('v-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transInfo.seconds),
      expression: "transInfo.seconds"
    }],
    staticClass: "size-small",
    domProps: {
      "value": (_vm.transInfo.seconds)
    },
    on: {
      "input": function($event) {
        _vm.transInfo.seconds = $event
      }
    },
    nativeOn: {
      "input": function($event) {
        _vm.hideErrmsg($event)
      }
    }
  }), _vm._v("秒"), _c('em', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errmsgShow),
      expression: "errmsgShow"
    }],
    staticClass: "error"
  }, [_vm._v("请输入平均访问时长")])], 1)]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("预期收益：")]), _c('div', {
    staticClass: "control"
  }, [_c('v-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transInfo.income),
      expression: "transInfo.income"
    }],
    attrs: {
      "rules": _vm.rules.income,
      "placeholder": "请输入数字"
    },
    domProps: {
      "value": (_vm.transInfo.income)
    },
    on: {
      "input": function($event) {
        _vm.transInfo.income = $event
      }
    }
  }), _vm._v("元")], 1)])]) : _vm._e(), (_vm.transtype === '4') ? _c('div', {
    staticClass: "trans-content"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("平均访问页数：")]), _c('div', {
    staticClass: "control ml5"
  }, [_vm._v("大于"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transInfo.accpage),
      expression: "transInfo.accpage"
    }],
    staticClass: "size-small",
    on: {
      "change": [function($event) {
        _vm.transInfo.accpage = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }, _vm.hideErrmsg]
    }
  }, _vm._l((_vm.pagesList), function(page) {
    return _c('option', {
      domProps: {
        "value": page
      }
    }, [_vm._v(_vm._s(page))])
  })), _vm._v("页"), (_vm.errmsgShow) ? _c('em', {
    staticClass: "error"
  }, [_vm._v("请选择页数")]) : _vm._e()])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("预期收益：")]), _c('div', {
    staticClass: "control"
  }, [_c('v-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transInfo.income),
      expression: "transInfo.income"
    }],
    attrs: {
      "rules": _vm.rules.income,
      "placeholder": "请输入数字"
    },
    domProps: {
      "value": (_vm.transInfo.income)
    },
    on: {
      "input": function($event) {
        _vm.transInfo.income = $event
      }
    }
  }), _vm._v("元")], 1)])]) : _vm._e(), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-small",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("确认")]), _c('button', {
    staticClass: "btn btn-default btn-small",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("取消")])])])], 1)]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("转化类型细分")]), _c('th', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v("转化统计指标")]), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("操作")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2e63608c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2e63608c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/setting/trans.vue
// module id = 735
// module chunks = 0